'use client';

import { ThemeProvider } from 'next-themes';
import { UserProvider } from '../components/Navigation';

export function Providers({ children }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <UserProvider>
        {children}
      </UserProvider>
    </ThemeProvider>
  );
}
